export default "__VITE_ASSET__D6m2E779__"